module.exports = __webpack_public_path__ + "static/media/tuer.738f9d83.jpg";